import React from 'react';
import { HeaderLabelsViewModel } from '../../typings/viewModels/headerLabelsViewModel';
import ScreenReaderOnly from '../ScreenReaderOnly/ScreenReaderOnly';

type ExpandIndicatorProps = {
  isExpanded: boolean;
  labels?: HeaderLabelsViewModel;
  style?: 'default' | 'compact';
  className?: string;
  shouldIgnoreAccessiblity?: boolean;
  isInteractiveElement?: boolean;
};

function ExpandIndicator({
  isExpanded,
  labels,
  style = 'default',
  className = '',
  shouldIgnoreAccessiblity = false,
  isInteractiveElement = true,
}: ExpandIndicatorProps): JSX.Element {
  const Element = isInteractiveElement ? 'button' : 'div';

  return (
    <Element
      className={`expand-indicator__wrapper expand-indicator--${style} ${
        isExpanded ? 'expand-indicator--expanded' : ''
      } ${className}`}
      tabIndex={
        !isInteractiveElement || shouldIgnoreAccessiblity ? -1 : undefined
      }
    >
      <i
        className='expand-indicator__icon zmdi zmdi-caret-down'
        aria-hidden={true}
      />
      <ScreenReaderOnly>
        {/*trans() might not be available on CMS, on header we should have .labels available*/}
        {labels
          ? isExpanded
            ? labels.accessibilityCollapse
            : labels.accessibilityExpand
          : isExpanded
          ? trans('global.accessibilityExpand')
          : trans('global.accessibilityCollapse')}
      </ScreenReaderOnly>
    </Element>
  );
}

export default ExpandIndicator;
